import data from "../../../../data/schema/shared/sharedData";

export default {
  name: "Agricultural Business Profile",
  sections: [
    {
      name: "Agricultural Business",
      fields: [
        {
          machine_name: "new_profile_agriculture_emp_name",
          widget: "text",
          label: "Name of Agricultural Business",
          maxLength: 60,
          validate: [
            {
              minLength: 5,
              message:
                "Bad format: Name of Agricultural Business must contain at least 5 characters.",
            },
          ],
          tooltip: "Enter the name of your agricultural business.",
        },
        {
          machine_name: "new_profile_agriculture_worksite_address",
          widget: "text",
          label: "Worksite Address",
          maxLength: 120,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Bad format: Worksite address must contain at least 5 characters.",
            },
          ],
          tooltip: "Enter the worksite address.",
        },
        {
          machine_name: "new_profile_agriculture_city",
          widget: "text",
          validate: [
            {
              minLength: 2,
              message: "Bad format: City must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          label: "City",
          tooltip: "Enter the city.",
        },
        {
          machine_name: "new_profile_agriculture_state",
          widget: "select",
          validate: ["required"],
          state: true,
          selection: data.state,
          label: "State",
          tooltip: "Select the state.",
        },
        {
          machine_name: "new_profile_agriculture_county",
          widget: "countyselect",
          required: true,
          validate: [
            "required",
            {
              required_county: "new_profile_agriculture_state",
              message: "",
              needsFieldValues: true,
            },
          ],
          label: "County",
          disabled: true,
          disableWhenField: "new_profile_agriculture_state",
          tooltip: "Select the county of the worksite location.",
        },
        {
          machine_name: "new_profile_agriculture_zip",
          widget: "text",
          maxLength: 10,
          validate: ["postalUSA"],
          label: "Postal Code",
          tooltip: "Enter the zip code.",
        },
        {
          machine_name: "new_profile_agriculture_add_emp_info",
          widget: "text_area",
          maxLength: 500,
          label: "Additional Place of Employment Information",
          placeholder: "",
          width: 8,
          rows: 10,
          inputLimit: 500,
          validate: [
            {
              minLength: 5,
            },
          ],
          tooltip: "Enter additional places of Employment Information.",
        },
      ],
    },
    {
      name: "Profile Name",
      coloring: "blue",
      fields: [
        {
          machine_name: "new_profile_agriculture_profile_name",
          widget: "text",
          label: "What would you like to name this profile?",
          maxLength: 60,
          validate: ["required"],
          tooltip:
            "Enter a unique name that will allow you to identify this profile",
        },
      ],
    },
  ],
};
